import { RouteRecordRaw } from 'vue-router'


const routes: Array<RouteRecordRaw> = [
  {
    path: '/mhome',
    name: 'mHome',
    meta: {
      title: '工作台'
    },
    redirect: '/mhome/head-page',
    component: ()=> import(/* webpackChunkName: "about" */ '../views/mobileView/mobileLayout.vue'),
    children: [
      {
        path: 'conversion-scripts', name: 'mConversionScripts',
        meta: { title: '话术库', requiresBusiness: true, containContent: true, canBack: true, hasTabbar: false, hasNavbar: true },
        component: () => import('../views/mobileView/conversionScripts.vue')
      },
      {
        path: 'douyin-screening', name: 'mDouyinScreening',
        meta: { title: '抖音截流', requiresBusiness: true, containContent: true, canBack: true, hasTabbar: false, hasNavbar: true },
        component: () => import('../views/mobileView/douyinScreening.vue')
      },
      {
        path: 'posters', name: 'mPosterHub',
        meta: { title: '海报', hasTabbar: true, hasNavbar: true },
        component: () => import('../views/mobileView/posterHub.vue')
      },
      {
        path: 'sporttery-basketball-poster', name: 'mSportteryBasketballPoster',
        meta: { title: '篮球赛果海报', containContent: true, requiresBusiness: true, canBack: true, hasTabbar: false, hasNavbar: true },
        props: { sport: 'basketball' },
        component: () => import('../views/mobileView/sportteryPoster.vue')
      },
      {
        path: 'sporttery-poster', name: 'mSportteryPoster',
        meta: { title: '足球赛果海报', containContent: true, requiresBusiness: true, canBack: true, hasTabbar: false, hasNavbar: true },
        component: () => import('../views/mobileView/sportteryPoster.vue')
      },
      {
        path: 'rest-days', name: 'mRestDays',
        meta: { title: '排班/预定', requiresRestEmployee: true, canBack: true, hasTabbar: false, hasNavbar: true },
        component: () => import('../views/mobileView/restDays.vue')
      },
      {
        path: 'dlt-poster',
        name: 'mDltPoster',
        meta: { title: '大乐透海报', requiresAdmin: true, canBack: true, hasTabbar: false, hasNavbar: true },
        component: () => import('../views/mobileView/dltPoster.vue')
      },
      {
        path: 'head-page',
        name: 'mHomePage',
        meta: {
          hasTabbar: true,
          title: '工作台',
          hasNavbar: false
        },
        component: ()=> import(/* webpackChunkName: "about" */ '../views/mobileView/home.vue')
      },
      {
        path: 'self-page',
        name: 'mSelfPage',
        meta: {
          hasTabbar: true,
          title: '中心',
          hasNavbar: false
        },
        component: ()=> import(/* webpackChunkName: "about" */ '../views/mobileView/myInfo.vue')
      },
      {
        path: 'fb-data',
        name: 'mFbData',
        meta: {
          title: '足球数据',
          canBack: true,
          hasTabbar: false,
          hasNavbar: true
        },
        component: ()=> import(/* webpackChunkName: "about" */ '../views/mobileView/mfbData.vue')
      },
      {
        path: 'calculator',
        name: 'calculator',
        meta: {
          title: '赔率计算工具',
          canBack: true,
          hasTabbar: false,
          hasNavbar: true
        },

        component: ()=> import(/* webpackChunkName: "about" */ '../views/mobileView/calculator.vue')
      },
      {
        path: 'plan-calc',
        name: 'planCalc',
        meta: {
          title: '方案选择工具',
          canBack: true,
          hasTabbar: false,
          hasNavbar: true
        },
        component: ()=> import(/* webpackChunkName: "about" */ '../views/mobileView/planSelector.vue')
      },
      {
        path: 'plan-selector',
        name: 'planSelector',
        meta: {
          title: '方案选择工具',
          canBack: true,
          hasTabbar: false,
          hasNavbar: false
        },
        component: ()=> import(/* webpackChunkName: "about" */ '../views/mobileView/planSelectorGuide.vue')
      },
      {
        path: 'publish',
        name: 'publish',
        meta: {
          title: '沛奇发布',
          canBack: true,
          hasTabbar: false,
          hasNavbar: true
        },
        component: ()=> import(/* webpackChunkName: "about" */ '../views/mobileView/planPublish.vue')
      },
      {
        path: 'asset',
        name: 'asset',
        meta: {
          title: '资产核算',
          canBack: true,
          hasTabbar: false,
          hasNavbar: true
        },
        component: ()=> import(/* webpackChunkName: "about" */ '../views/mobileView/asset.vue')
      },
      {
        path: 'store',
        name: 'store',
        meta: {
          title: '我的门店数据',
          canBack: true,
          hasTabbar: false,
          hasNavbar: true
        },
        component: ()=> import(/* webpackChunkName: "about" */ '../views/mobileView/store.vue')
      },
      {
        path: 'tv-remote',
        name: 'mTvRemote',
        meta: {
          title: '电视遥控器',
          canBack: true,
          hasTabbar: false,
          hasNavbar: true
        },
        component: ()=> import(/* webpackChunkName: "about" */ '../views/mobileView/tvRemote.vue')
      },
      {
        path: 'account-create',
        name: 'mAccountCreate',
        meta: {
          title: '创建账号',
          requiresBusiness: true,
          canBack: true,
          hasTabbar: false,
          hasNavbar: true
        },
        component: ()=> import('../views/mobileView/accountCreate.vue')
      },
      {
        path: 'trend-authorize',
        name: 'trendAuthorize',
        meta: { title: '走势图授权', canBack: true, hasTabbar: false, hasNavbar: true },
        component: ()=> import('../views/mobileView/trendAuthorize.vue')
      },
      {
        path: 'trend-manage',
        name: 'trendManage',
        meta: { title: '走势图管理', canBack: true, hasTabbar: false, hasNavbar: true },
        component: ()=> import('../views/mobileView/trendManage.vue')
      }
    ]
  }
]


export default routes
